import { createStore } from "vuex";
import find from "lodash/find";
import clients from "./modules/clients";
import rotas from "./modules/rotas";
import rotausers from "./modules/rotausers";
import rotaactivities from "./modules/rotaactivities";
import rotaagencies from "./modules/rotaagencies";
import rotaoncall from "./modules/rotaoncall";
import users from "./modules/users";
import config from "../config";

const storeConfig = {
  modules: {
    clients,
    rotas,
    rotausers,
    rotaactivities,
    rotaagencies,
    rotaoncall,
    users,
  },
  state: {
    dutiesQualifiedFor: config.dutiesQualifiedFor,
    locations: config.locations,
  },
  getters: {
    dutiesQualifiedFor: (state) => state.dutiesQualifiedFor,
    getDutyShortname: (state) => (duty) => {
      const dutyQualifiedFor = find(state.dutiesQualifiedFor, { value: duty });
      if (dutyQualifiedFor) {
        return dutyQualifiedFor.shortName;
      }
      return duty;
    },
    locations: (state) => state.locations,
    getLocationNameFromId: (state) => (locationId) => {
      const location = find(state.locations, { value: locationId });
      if (location) {
        return location.name;
      }
      return `* ${locationId}`;
    },
  },
  mutations: {},
  actions: {},
};

export default createStore(storeConfig);
